import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=e0057f4e&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0057f4e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e0057f4e')) {
      api.createRecord('e0057f4e', component.options)
    } else {
      api.reload('e0057f4e', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=e0057f4e&scoped=true&", function () {
      api.rerender('e0057f4e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2fJFzR14IpasJ/JS/comp/SearchFilterTokens.vue"
export default component.exports